// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing {
  background-color: transparent;
  padding: 100px 0px 100px 0px;
  margin: 2.5rem;
  margin-bottom: 0;
  margin-top: 10rem;
  text-align: left;
  min-height: 100vh;
  position: relative;
  z-index: 1;
  display: grid;
  justify-content: center;
  align-items: center;
}

body {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 320px;
  min-height: 100vh;
}

.content {
  font-family: "Roboto", sans-serif;
  line-height: 1.7;
  color: #4a4a4a;
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
}

.landing p,
.landing li {
  font-size: 1rem;
  margin-bottom: 25px;
  color: #6a6a6a;
  text-align: left;
  margin-left: 10vw;
  margin-right: 10vw;
}

.intro {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.content h1 {
  font-size: 3rem;
  color: #2c2c2c;
  margin-bottom: 30px;
  text-align: left;
  font-weight: 500;
}

.content ul {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 25px;
  display: flex;
  justify-content: left;
  align-items: center;
}

.content li {
  font-size: 1rem;
  margin-bottom: 15px;
  color: #6a6a6a;
  position: relative;
  padding-left: 20px;
}

.content li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #6a6a6a;
  font-size: 1rem;
  line-height: 1;
}

.contactus {
  color: #247a97;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 2.5rem;
}

.landing-quote {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;
  width: 100%;
  margin: 4rem 0 4rem 0;
}

.landing-quote-btn {
  background-color: #247a97;
  fill: #ffffff;
  color: #ffffff;
  border-color: white;
  position: relative;
  letter-spacing: 0.5px;
  transition: transform 0.3s;
  font-size: 2rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0px 10px 0px;
  padding: 15px 40px 15px 40px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
}

.landing-quote-btn:hover {
  background-color: #76bbe9;
  transform: scale(0.9);
  border-color: white;
  cursor: pointer;
}

.rating-column {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 75%;
  height: auto;
  margin: 0 auto;
  margin-top: 0;
  margin-bottom: 4rem;
  gap: 1rem;
}

.header-image {
  width: calc(100% / 3);
  height: auto;
  margin-left: 1rem;
  margin-right: 1rem;
}

/* Services Section */
.services-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  width: 90vw;
  margin-left: 5vw;
  margin-right: 5vw;
}

.service-item {
  flex: 1;
  min-width: calc(33.33% - 1rem);
  text-align: center;
  padding: 1rem;
  border: 1px solid #e2e2e2;
  background-color: #f9f9f9;
  border-radius: 10px;

  &:hover {
    background-color: #e2e2e2;
    transform: scale(0.95);
  }
}

.service-item h2 {
  font-size: 2.5rem;
  color: #247a97;
}

.service-item p {
  font-size: 1rem;
  color: #6a6a6a;
  margin: 2.5rem;
  text-indent: 2.5rem;
}

.landing .intro {
  font-size: 2.5rem;
  color: #247a97;
  position: relative;
  text-align: center;
}
.landing-gutter-styles {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 2.5rem;
}

.landing-gutter-styles ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.landing-gutter-styles li {
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 15px;
  color: #247a97;
  text-align: left;
  flex: 0 0 calc(33.33% - 1rem);
}

.commitment p {
  margin-bottom: -1rem;
  width: 80vw;
  margin-left: 10vw;
  margin-right: 10vw;
}

/* Responsive design for smaller screens ≤ 600px*/
@media (max-width: 600px) {
  .landing .intro {
    font-size: 1rem;
    margin: 0;
    margin-top: 3rem;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .landing p {
    font-size: 1rem;
    margin-left: 5%;
    margin-right: 5%;
    padding: 0 1rem;
  }

  .landing h1 {
    margin-top: 2.5rem;
    font-size: 2.5rem;
  }

  .landing h2 {
    font-size: 1.75rem;
  }

  .services-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100vw;
  }

  .service-item h2 {
    display: block;
    justify-content: center;
    padding: 1rem 1rem;
    flex: 0 0 auto;
    width: 95vw;
    text-align: center;
  }

  .service-item p {
    font-size: 1rem;
    display: block;
    justify-content: center;
    padding: 1rem 1rem;
    flex: 0 0 auto;
    width: 95vw;
    text-align: left;
  }

  .landing-quote {
    gap: 0;
  }

  .landing-quote-btn {
    padding: 10px 10px 0 0;
  }
}

/* Responsive design for smaller screens 601px to 768px*/
@media (max-width: 768px) {
  .landing p {
    margin: 1rem 2.5rem;
    font-size: 1.75rem;
  }

  .landing-quote {
    gap: 0;
  }

  .landing-quote-btn {
    padding: 20px 20px 20px 0;
  }
}

/* Media query for screens 769px 992px */
@media screen and (max-width: 992px) {
  .landing {
    margin: 0;
  }

  .landing p {
    font-size: 1.75rem;
    margin-left: 7%;
    margin-right: 7%;
    margin-top: 1rem;
  }

  .phone-btn,
  .quote-btn {
    width: 10em;
  }

  .landing-quote {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
  }

  .landing-quote-btn {
    width: 80%;
  }

  .landing h2 {
    position: relative;
    text-align: center;
  }

  .landing .rating-column {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    max-width: calc(100% - 2.5rem);
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .header-image {
    width: 50%;
  }

  .service-item {
    width: calc(50% - 1rem);
  }
}

@media screen and (max-width: 1200px) {
  .landing {
    margin: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .landing p {
    font-size: 1.75rem;
    margin-left: 7%;
    margin-right: 7%;
    margin-top: 1rem;
  }
  .landing-gutter-styles {
    justify-content: center;
  }

  .landing-gutter-styles li {
    flex: 0 0 calc(50% - 1rem);
  }

  .landing .rating-column {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    max-width: 80vw;
    margin-bottom: 5rem;
  }

  .landing .rating-column img {
    width: 25vw;
    height: auto;
  }
}

@media screen and (min-width: 1200px) {
  .landing {
    margin: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .landing p {
    font-size: 1.75rem;
    margin-left: 7%;
    margin-right: 7%;
    margin-top: 1rem;
  }
  .landing-gutter-styles {
    justify-content: center;
  }

  .landing-gutter-styles li {
    flex: 0 0 calc(50% - 1rem);
  }

  .landing .rating-column {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    max-width: 80vw;
    margin-bottom: 5rem;
  }

  .landing .rating-column img {
    width: 25vw;
    height: auto;
  }
}

/*
When creating mobile first responsive design go with the following 
https://www.youtube.com/watch?v=K24lUqcT0Ms&pp=ygUVcmVzcG9uc2l2ZSBkZXNpZ24gY3Nz

Method 1: 

.container {
  width: 90%;
  margin: 0 auto:
}

Method 2 (Better Method):

.container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: .5rem;
  padding-right: .5rem;
}

breakpoints:

xs
@media (min-width: 475px) {
  .container {
    max-width: 475px;
  }
}

sm
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

md
@media (min-width: 768px) {}

lg
@media (min-width: 1024px) {}

xl
@media (min-width: 1280px) {}

xxl
@media (min-width: 1536px) {}

*/
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Landing.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B;0DACwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;;EAEnB;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiDC","sourcesContent":[".landing {\n  background-color: transparent;\n  padding: 100px 0px 100px 0px;\n  margin: 2.5rem;\n  margin-bottom: 0;\n  margin-top: 10rem;\n  text-align: left;\n  min-height: 100vh;\n  position: relative;\n  z-index: 1;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 320px;\n  min-height: 100vh;\n}\n\n.content {\n  font-family: \"Roboto\", sans-serif;\n  line-height: 1.7;\n  color: #4a4a4a;\n  padding: 40px;\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: left;\n}\n\n.landing p,\n.landing li {\n  font-size: 1rem;\n  margin-bottom: 25px;\n  color: #6a6a6a;\n  text-align: left;\n  margin-left: 10vw;\n  margin-right: 10vw;\n}\n\n.intro {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.content h1 {\n  font-size: 3rem;\n  color: #2c2c2c;\n  margin-bottom: 30px;\n  text-align: left;\n  font-weight: 500;\n}\n\n.content ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin-bottom: 25px;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n.content li {\n  font-size: 1rem;\n  margin-bottom: 15px;\n  color: #6a6a6a;\n  position: relative;\n  padding-left: 20px;\n}\n\n.content li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #6a6a6a;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.contactus {\n  color: #247a97;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 2.5rem;\n}\n\n.landing-quote {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2.5rem;\n  width: 100%;\n  margin: 4rem 0 4rem 0;\n}\n\n.landing-quote-btn {\n  background-color: #247a97;\n  fill: #ffffff;\n  color: #ffffff;\n  border-color: white;\n  position: relative;\n  letter-spacing: 0.5px;\n  transition: transform 0.3s;\n  font-size: 2rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0px 10px 0px;\n  padding: 15px 40px 15px 40px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n}\n\n.landing-quote-btn:hover {\n  background-color: #76bbe9;\n  transform: scale(0.9);\n  border-color: white;\n  cursor: pointer;\n}\n\n.rating-column {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 75%;\n  height: auto;\n  margin: 0 auto;\n  margin-top: 0;\n  margin-bottom: 4rem;\n  gap: 1rem;\n}\n\n.header-image {\n  width: calc(100% / 3);\n  height: auto;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n/* Services Section */\n.services-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n  width: 90vw;\n  margin-left: 5vw;\n  margin-right: 5vw;\n}\n\n.service-item {\n  flex: 1;\n  min-width: calc(33.33% - 1rem);\n  text-align: center;\n  padding: 1rem;\n  border: 1px solid #e2e2e2;\n  background-color: #f9f9f9;\n  border-radius: 10px;\n\n  &:hover {\n    background-color: #e2e2e2;\n    transform: scale(0.95);\n  }\n}\n\n.service-item h2 {\n  font-size: 2.5rem;\n  color: #247a97;\n}\n\n.service-item p {\n  font-size: 1rem;\n  color: #6a6a6a;\n  margin: 2.5rem;\n  text-indent: 2.5rem;\n}\n\n.landing .intro {\n  font-size: 2.5rem;\n  color: #247a97;\n  position: relative;\n  text-align: center;\n}\n.landing-gutter-styles {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 2.5rem;\n}\n\n.landing-gutter-styles ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.landing-gutter-styles li {\n  font-size: 1.75rem;\n  font-weight: 800;\n  margin-bottom: 15px;\n  color: #247a97;\n  text-align: left;\n  flex: 0 0 calc(33.33% - 1rem);\n}\n\n.commitment p {\n  margin-bottom: -1rem;\n  width: 80vw;\n  margin-left: 10vw;\n  margin-right: 10vw;\n}\n\n/* Responsive design for smaller screens ≤ 600px*/\n@media (max-width: 600px) {\n  .landing .intro {\n    font-size: 1rem;\n    margin: 0;\n    margin-top: 3rem;\n    margin-bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .landing p {\n    font-size: 1rem;\n    margin-left: 5%;\n    margin-right: 5%;\n    padding: 0 1rem;\n  }\n\n  .landing h1 {\n    margin-top: 2.5rem;\n    font-size: 2.5rem;\n  }\n\n  .landing h2 {\n    font-size: 1.75rem;\n  }\n\n  .services-container {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: 100vw;\n  }\n\n  .service-item h2 {\n    display: block;\n    justify-content: center;\n    padding: 1rem 1rem;\n    flex: 0 0 auto;\n    width: 95vw;\n    text-align: center;\n  }\n\n  .service-item p {\n    font-size: 1rem;\n    display: block;\n    justify-content: center;\n    padding: 1rem 1rem;\n    flex: 0 0 auto;\n    width: 95vw;\n    text-align: left;\n  }\n\n  .landing-quote {\n    gap: 0;\n  }\n\n  .landing-quote-btn {\n    padding: 10px 10px 0 0;\n  }\n}\n\n/* Responsive design for smaller screens 601px to 768px*/\n@media (max-width: 768px) {\n  .landing p {\n    margin: 1rem 2.5rem;\n    font-size: 1.75rem;\n  }\n\n  .landing-quote {\n    gap: 0;\n  }\n\n  .landing-quote-btn {\n    padding: 20px 20px 20px 0;\n  }\n}\n\n/* Media query for screens 769px 992px */\n@media screen and (max-width: 992px) {\n  .landing {\n    margin: 0;\n  }\n\n  .landing p {\n    font-size: 1.75rem;\n    margin-left: 7%;\n    margin-right: 7%;\n    margin-top: 1rem;\n  }\n\n  .phone-btn,\n  .quote-btn {\n    width: 10em;\n  }\n\n  .landing-quote {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: left;\n  }\n\n  .landing-quote-btn {\n    width: 80%;\n  }\n\n  .landing h2 {\n    position: relative;\n    text-align: center;\n  }\n\n  .landing .rating-column {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    max-width: calc(100% - 2.5rem);\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n\n  .header-image {\n    width: 50%;\n  }\n\n  .service-item {\n    width: calc(50% - 1rem);\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .landing {\n    margin: 0;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .landing p {\n    font-size: 1.75rem;\n    margin-left: 7%;\n    margin-right: 7%;\n    margin-top: 1rem;\n  }\n  .landing-gutter-styles {\n    justify-content: center;\n  }\n\n  .landing-gutter-styles li {\n    flex: 0 0 calc(50% - 1rem);\n  }\n\n  .landing .rating-column {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 3rem;\n    max-width: 80vw;\n    margin-bottom: 5rem;\n  }\n\n  .landing .rating-column img {\n    width: 25vw;\n    height: auto;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .landing {\n    margin: 0;\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .landing p {\n    font-size: 1.75rem;\n    margin-left: 7%;\n    margin-right: 7%;\n    margin-top: 1rem;\n  }\n  .landing-gutter-styles {\n    justify-content: center;\n  }\n\n  .landing-gutter-styles li {\n    flex: 0 0 calc(50% - 1rem);\n  }\n\n  .landing .rating-column {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 3rem;\n    max-width: 80vw;\n    margin-bottom: 5rem;\n  }\n\n  .landing .rating-column img {\n    width: 25vw;\n    height: auto;\n  }\n}\n\n/*\nWhen creating mobile first responsive design go with the following \nhttps://www.youtube.com/watch?v=K24lUqcT0Ms&pp=ygUVcmVzcG9uc2l2ZSBkZXNpZ24gY3Nz\n\nMethod 1: \n\n.container {\n  width: 90%;\n  margin: 0 auto:\n}\n\nMethod 2 (Better Method):\n\n.container {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: .5rem;\n  padding-right: .5rem;\n}\n\nbreakpoints:\n\nxs\n@media (min-width: 475px) {\n  .container {\n    max-width: 475px;\n  }\n}\n\nsm\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\nmd\n@media (min-width: 768px) {}\n\nlg\n@media (min-width: 1024px) {}\n\nxl\n@media (min-width: 1280px) {}\n\nxxl\n@media (min-width: 1536px) {}\n\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
